// @ts-nocheck
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link, useRouteMatch } from 'react-router-dom';
import dx from '../../dx';
import $ from 'jquery';

export default class ModuleLink extends Component<any, any> {
    [key: string]: any;
    static [key: string]: any;
    static propTypes = {
        tooltip: PropTypes.bool,
        active: PropTypes.bool,
        label: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
        aHrefLink: PropTypes.bool,
        icon: PropTypes.string.isRequired,
        partnerId: PropTypes.number,
        renterId: PropTypes.number,
        onClickLink: PropTypes.func.isRequired,
        target: PropTypes.string,
        rel: PropTypes.string,
        onClick: PropTypes.func,
        id: PropTypes.string,
        hasUnread: PropTypes.bool,
        isOutdated: PropTypes.bool,
    };

    static defaultProps = {};

    componentDidMount() {
        this.componentDidUpdate();
    }

    componentDidUpdate() {
        if (this.props.tooltip) {
            $(this.listItem).tooltip({
                container: 'body',
                placement: 'right',
            });
        } else {
            $(this.listItem).tooltip('destroy');
        }
    }

    render() {
        const className = [this.props.active ? 'active' : '', this.props.hasUnread ? 'changelog-has-unread' : '']
            .filter(Boolean)
            .join(' ');
        return (
            <li ref={el => (this.listItem = el)} id={this.props.id} className={className} title={this.props.label} data-e2e={`sidebar-link-${this.props.label.toLowerCase().replace(/[\s()]+/g, '-')}`}>
                <MaybePageLoadLink
                    onClickLink={this.props.onClickLink}
                    url={this.props.url}
                    partnerId={this.props.partnerId}
                    renterId={this.props.renterId}
                    aHrefLink={this.props.aHrefLink}
                    target={this.props.target}
                    rel={this.props.rel}
                    onClick={this.props.onClick}
                    isOutdated={this.props.isOutdated}
                >
                    <i className={`fa fa-${this.props.icon} fa-fw`} />
                    <span className="main-sidebar-label">&nbsp;{this.props.label}</span>
                </MaybePageLoadLink>
            </li>
        );
    }
}

const MaybePageLoadLink = ({
    url,
    partnerId,
    renterId,
    onClickLink,
    aHrefLink,
    isOutdated,
    target,
    rel,
    onClick,
    children,
}) => {
    const handleAnchorClick = e => {
        onClickLink && onClickLink(e);
        onClick && onClick(e);
    };
    const routeMatches = useRouteMatch(url);
    const useFullPageLoad =
        isOutdated ||
        routeMatches ||
        partnerId !== dx.utils.getPartnerIdFromUrl(url) ||
        renterId !== dx.utils.getRenterIdFromUrl(url) ||
        aHrefLink;
    if (useFullPageLoad) {
        return (
            <a href={url} target={target} rel={rel} onClick={handleAnchorClick}>
                {children}
            </a>
        );
    } else {
        return (
            <Link to={url} onClick={onClickLink}>
                {children}
            </Link>
        );
    }
};
MaybePageLoadLink.propTypes = {
    url: PropTypes.string.isRequired,
    partnerId: PropTypes.number,
    renterId: PropTypes.number,
    onClickLink: PropTypes.func,
    aHrefLink: PropTypes.bool,
    target: PropTypes.string,
    rel: PropTypes.string,
    onClick: PropTypes.func,
    isOutdated: PropTypes.bool,
};
